import { css } from "styled-system/css";
import { MessageCircle, Phone } from "lucide-react";
import { waMeDigitsFromPhone } from "@/lib/whatsapp-chat-url";

const WHATSAPP_MESSAGE = "Hola, quiero reservar un turno";

export function PrivateAgendaContact({ name, phone }: { name: string; phone: string | null }) {
  const waDigits = waMeDigitsFromPhone(phone);
  const waUrl = waDigits ? `https://wa.me/${waDigits}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}` : null;
  const hasPhone = Boolean(phone?.trim());

  return (
    <div
      className={css({
        display: "flex",
        flexDir: "column",
        alignItems: "center",
        textAlign: "center",
        gap: "4",
        py: { base: "6", md: "10" },
        px: "4",
      })}
    >
      <p className={css({ fontSize: "sm", color: "var(--pp-muted, #64748b)", lineHeight: "1.6", maxW: "26rem" })}>
        {hasPhone
          ? "Para reservar un turno comunicate con nosotros:"
          : `Contactate directamente con ${name} para reservar tu turno.`}
      </p>

      {hasPhone ? (
        <div className={css({ display: "flex", flexDir: "column", gap: "3", w: "100%", maxW: "20rem" })}>
          {waUrl ? (
            <a
              href={waUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={css({
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "2",
                px: "5",
                py: "3",
                rounded: "lg",
                fontSize: "sm",
                fontWeight: "semibold",
                color: "white",
                bg: "#25D366",
                textDecoration: "none",
                transition: "transform 160ms cubic-bezier(0.23, 1, 0.32, 1)",
                _hover: { opacity: 0.92 },
                _active: { transform: "scale(0.98)" },
              })}
            >
              <MessageCircle size={18} strokeWidth={2} aria-hidden />
              Escribir por WhatsApp
            </a>
          ) : null}

          <a
            href={`tel:${phone!.trim()}`}
            className={css({
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "2",
              px: "5",
              py: "3",
              rounded: "lg",
              fontSize: "sm",
              fontWeight: "semibold",
              color: "var(--pp-text, #0f172a)",
              bg: "transparent",
              borderWidth: "1px",
              borderColor: "var(--pp-border, #e2e8f0)",
              textDecoration: "none",
              transition: "transform 160ms cubic-bezier(0.23, 1, 0.32, 1)",
              _hover: { bg: "rgba(15, 23, 42, 0.04)" },
              _active: { transform: "scale(0.98)" },
            })}
          >
            <Phone size={18} strokeWidth={2} aria-hidden />
            {phone!.trim()}
          </a>
        </div>
      ) : null}
    </div>
  );
}
